<template>
  <footer id="seeAlso">

    <div class="brand" ref="brand">

      <img src="../../assets/logo.svg" alt="logo" @click="goIndex" :style="{cursor:'pointer'}">
      <h4>Nethanzêl's Showroom</h4>

      <div class="media">
        <a href="https://github.com/Nethanzel" target="_blank"><img src="../../assets/icons/githubb.png" alt="github"></a>
        <a href="https://www.linkedin.com/in/natanael-abad-136404176" target="_blank"><img src="../../assets/icons/linkend.png" alt="linkedin"></a>
        <!-- <a href="https://facebook.com/natanaelabaad" target="_blank"><img src="../../assets/icons/facebook.png" alt="facebook"></a> -->
      </div>

    </div>

    <div class="about" v-if="$route.fullPath != '/contact'" ref="about">
      <p>Are you interested?</p>
      <p><router-link to="/contact"><span>Get in touch</span></router-link></p>
      <p><a @click="openCVOptions()" :style="{ cursor: 'pointer' }"><span>Download my CV</span></a></p>
    </div>

    <div class="more" ref="more">
      <p>Have a look to...</p>
      <p v-if="$route.fullPath != '/experience'"><router-link to="/experience"><span>My experience as developer</span></router-link></p>
      <p v-if="$route.fullPath != '/projects'"><router-link to="/projects"><span>Projects that I've done</span></router-link></p>
      <p v-if="$route.fullPath != '/about'"><router-link to="/about"><span>More about me</span></router-link></p>
    </div>

    <div class="lastupdated" ref="lastU">
      <p class="updated">Natanael Abad - 2023</p>
    </div>

    <div class="cvOptions" ref="cvOptions">
      <div>
        <i class="icofont-close" @click="hideCVOptions()"></i>
      </div>
      <p><a href="/docs/cv/nethanzels_cv.pdf" target="_blank" ><span>English document</span></a></p>
      <p><a href="/docs/cv/nethanzels_cv_sp.pdf" target="_blank" ><span>Documento en español</span></a></p>
    </div>
    
  </footer>
</template>

<script>
  export default {
    methods: {
      goIndex() {
        window.location.href = "http://nethanzel.dev";
      },
      openCVOptions() {
        this.hideSections();
        this.$refs.cvOptions.style.display = "flex";

        setTimeout(() => {
          this.$refs.cvOptions.style.display = "none";
          this.showSections();
        }, 20000)
      },
      hideCVOptions() {
        this.$refs.cvOptions.style.display = "none";
        this.showSections();
      },
      hideSections() {
        this.$refs.brand.style.opacity = "0";
        this.$refs.about.style.opacity = "0";
        this.$refs.more.style.opacity = "0";
        this.$refs.lastU.style.opacity = "0";
      },
      showSections() {
        this.$refs.brand.style.opacity = "1";
        this.$refs.about.style.opacity = "1";
        this.$refs.more.style.opacity = "1";
        this.$refs.lastU.style.opacity = "1";
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (prefers-color-scheme: dark) {
    .brand {
      color: #fff;
    }

    .cvOptions {
      div {
        i {
          color: #000;
          background-color: #fff;
        }
      }
    }

    p {
      color: #fff;
      span {
        background-color: #fff;
        color: #000;
      }
      a:hover {
        outline: 2px solid #fff;
      }
      a:hover span {
        color: #fff;
        background: #000;
      }
    }

    .media {
      img {
        filter: invert(0);
      }
    }
  }

  @media (prefers-color-scheme: light) {
    .brand {
      color: #000;
    }

    .cvOptions {
      div {
        i {
          color: #fff;
          background-color: #000;
        }
      }
    }

    p {
      color: #000;
      span {
        background-color: #000;
        color: #fff;
      }
      a:hover {
        outline: 2px solid #000;
      }
      a:hover span {
        color: #000;
        background: #fff;
      }
    }

    .media {
      img {
        filter: invert(1);
      }
    }
  }

#seeAlso {
  padding-top: 2em;
  margin: 0px auto 0 auto;
  background: transparent;
  max-width: 1150px;
  width: auto;
  height: auto;
  position: relative;
  padding-bottom: 2em;
  
  display: grid;
  grid-template-rows: 2;
  grid-template-columns: 4;
  grid-template-areas: 'ga1 ga1 ga2 ga3'
                       'ga1 ga1 ga4 ga4';
                       
  user-select: none;
}

.brand {
  grid-area: ga1;
  height: 150px;
  transition: .4s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-bottom: 5px;
    height: 35px;
    width: auto;
    object-fit: cover;
  }
  p {
    font-size: 10px;
  }
}
.about {
  grid-area: ga2;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.more {
  grid-area: ga3;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  align-items: flex-start;

}
.lastupdated {
  grid-area: ga4;
  min-width: 100%;
  min-height: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.cvOptions {
  position: absolute;
  width: 100%;
  height: 100%;
  //display: flex;
  flex-direction: column;
  justify-content: center;
  display: none;
  animation: showUp .3s linear;
  p {
    margin: 15px 0;
    padding: 0;
    a {
      text-decoration: none;
      span {
        font-size: 18px;
        padding: 2px 10px;
      }
    }
  }

  div {
    display: flex;
    i {
      text-align: center;
      font-size: 20px;
      margin: 0 0 0 auto;
      border-radius: 50%;
      padding: 5px;
      cursor: pointer;
      transition: .4s;
    }
  }
}

@keyframes showUp {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

p {
  cursor: default;
  margin-bottom: 10px;
  transition: .4s;
  a {
    margin-left: 35px;
    padding: 1px 1px 1px 3px;
  }
  span {
    font-weight: bold;
    padding: 0px 4px;
    font-size: 14px;
  }
}

.updated {
  font-size: 13px;
  margin: 0;
  span {
    font-size: 13px;
  }
}

.media {
  margin-top: 8px;
  img {
    height: 23px;
    object-fit: cover;
    margin: 0 7px;
    transition: .4s;
  }
}

@media screen and (max-width: 1200px) {
  .cvOptions {
    div {
      padding-right: 100px;
    }
  }
}

@media screen and (max-width: 780px) {
  #seeAlso {
    grid-template-rows: 4;
    grid-template-columns: 1;
    grid-template-areas: 'ga3'
                         'ga2'
                         'ga1'
                         'ga4';
  }

  .brand {
    grid-area: ga1;
  }
  .about {
    grid-area: ga2;
    align-items: center;

    span {
      margin: 0;
    }
  }
  .more {
    grid-area: ga3;
    align-items: center;
    margin: 0 0 25px 0;

    span {
    margin: 0;
    }
  }
  .lastupdated {
    grid-area: ga4;
    align-items: center;
  }

  p {
    a {
      margin-left: 0px;
    }
  }
  .cvOptions {

    div {
      padding-bottom: 25px;
      i {
        margin: 0 3em 0 auto;
      }
    }
  }
}

</style>